<template>
  <button
    type="button"
    class="btn btn-theme position-relative"
    :title="indicatorTitle"
    :aria-label="indicatorTitle"
    @click="$emit('open')"
  >
    <i class="fas fa-inbox mr-1"></i> Generated Reports

    <span
      v-if="unreadCount > 0"
      class="reports-indicator badge badge-pill"
      :class="hasFailed ? 'badge-danger' : 'badge-deep-success'"
    >
      {{ displayCount }}
    </span>
    <span
      v-else-if="generating"
      class="reports-indicator reports-indicator--spinner text-muted"
    >
      <i class="fas fa-spin fa-circle-notch"></i>
    </span>
  </button>
</template>

<script>
export default {
  name: "GeneratedReportsButton",
  props: {
    unreadCount: { type: Number, default: 0 },
    hasFailed: { type: Boolean, default: false },
    generating: { type: Boolean, default: false },
  },
  emits: ["open"],
  computed: {
    displayCount() {
      return this.unreadCount > 9 ? "9+" : String(this.unreadCount);
    },
    indicatorTitle() {
      if (this.unreadCount > 0) {
        return `${this.unreadCount} new report${
          this.unreadCount === 1 ? "" : "s"
        } ready`;
      }
      if (this.generating) {
        return "A report is being generated…";
      }
      return "Generated Reports";
    },
  },
};
</script>

<style scoped lang="scss">
.reports-indicator {
  position: absolute;
  top: -7px;
  right: -7px;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  font-size: 0.7rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 2px var(--body-bg-color, #fff);
}

.reports-indicator--spinner {
  background: transparent;
  box-shadow: none;
  font-size: 0.8rem;
}
</style>
